/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

import React, { useEffect, useState, useCallback } from "react"

import { useHistory } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getFullMemberRows } from 'tableHelper'
import { getAPIToken, getGuilds, getAllMembers } from 'GaiaAPI'
import { calculateSS } from 'Utils'

function Members() {
    const history = useHistory();
    const [guilds, setGuilds] = useState([]);
    const [members, setMembers] = useState([]);
    const [memberRows, setMemberRows] = useState([]);

    const memberColumns = [
        { name: "pos", align: "left" },
        { name: "guild", align: "center" },
        { name: "name", align: "center" },
        { name: "power", align: "center" },
        { name: "power inc", align: "center" },
        { name: "ss", align: "center" },
        { name: "ccl", align: "center" },
        { name: "se score", align: "center" },
        { name: "se hard", align: "center" }
    ]

    function filterSearch(arr, query) {
        return arr.filter((el) => el.name.toLowerCase().includes(query.toLowerCase()));
    }

    const searchChanged = (event) => {
        try {
            //let filteredMembers = filterSearch(members, event.target.value);
            //let test = getFullMemberRows(memberColumns, filterSearch(members, event.target.value), guilds);
            setMemberRows(getFullMemberRows(memberColumns, filterSearch(members, event.target.value), guilds));
        }
        catch (error) {
            alert(error);
        }
    };

    const getDetails = useCallback(async () => {
        getUser()
            .then((result) => {
                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuilds(guildsResult);

                                getAllMembers(token)
                                    .then((membersResult) => {
                                        try {
                                            for (let i = 0; i < membersResult.length; i++) {
                                                membersResult[i].ss = calculateSS(membersResult[i]);
                                            }
                                            setMembers(membersResult);
                                            setMemberRows(getFullMemberRows(null, membersResult, guildsResult));
                                        }
                                        catch (error) {
                                            alert(error);
                                        }
                                    },
                                        (error) => {
                                            alert(error);
                                        });
                            },
                                (error) => {
                                    alert(error);
                                });
                    },
                        (error) => {
                            alert(error);
                        });
            },
                (error) => {
                    history.push('/authentication/sign-in');
                });
    }, [history]);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} xl={3}>
                            <Card sx={{ padding: "17px" }}>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                    <VuiTypography variant="lg" color="white">
                                        Alliance members
                                    </VuiTypography>
                                </VuiBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                            <Card sx={{ padding: "17px" }}>
                                <VuiInput
                                    onChange={searchChanged}
                                    placeholder="Search..."
                                    icon={{ component: "search", direction: "left" }}
                                    sx={({ breakpoints }) => ({
                                        [breakpoints.down("sm")]: {
                                            maxWidth: "80px",
                                        },
                                        [breakpoints.only("sm")]: {
                                            maxWidth: "80px",
                                        },
                                        backgroundColor: "info.main !important",
                                    })}
                                />
                            </Card>
                        </Grid>
                    </Grid>

                </VuiBox>
                <VuiBox mb={3}>
                    <Card>
                        <VuiBox
                            sx={{
                                "& th": {
                                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                        `${borderWidth[1]} solid ${grey[700]}`,
                                },
                                "& tr": {
                                    fontSize: 12,
                                },
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({
                                            borders: { borderWidth }, palette: { grey } }) =>
                                            `${borderWidth[1]} solid ${grey[700]}`,
                                    },
                                },
                            }}
                        >
                            <Table columns={memberColumns} rows={memberRows} />
                        </VuiBox>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Members;
